// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"1cc1d81c","116":"149a5afa","125":"e2d38372","147":"4f51265b","325":"7d23926f","333":"c8df257c","408":"8e9d158f","522":"a1a71461","807":"4f803d64","809":"228ba139","810":"624f206b","900":"926faf29","912":"87e24263","954":"328af905","966":"fd90c7c1"}[chunkId] + ".chunk.js";
};